._17e5ckx0 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._17e5ckx1 {
  display: flex;
  flex-direction: column;
}
._17e5ckx2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  display: block;
  margin-bottom: 8px;
}
._17e5ckx3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
._17e5ckx4 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  flex: 1;
}
._17e5ckx5 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  gap: 12px;
}
._17e5ckx6 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}